import * as React from 'react';
import { CollapsibleDropDown } from '../../../components/CollapsibleDropDown/CollapsibleDropDown';
import { darkAcqa, white } from '../../../consts/variables';
import { ICategory } from '../../../interfaces/IFAQPage';
import { FAQ } from '../components/FAQ';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        marginBottom: 15,
        boxShadow: '0 -1px 6px 0 rgba(0, 0, 0, 0.27)',
    },
    figure: {
        margin: 0,
        height: 130,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
    },
    title: {
        margin: 0,
        padding: '18px 0px 18px 10px',
        fontSize: 17,
        fontWeight: 'bold',
        color: white,
        alignItems: 'baseline',
    },
    arrowDownIcon: {
        fill: white,
        margin: '0 10px',
        paddingLeft: 0,
        paddingRight: 0,
    },
    wrapperStyle: {
        margin: 0,
        padding: 0,
        background: darkAcqa,
    },
    childStyle: {
        margin: 0,
        padding: 0,
        background: white,
    },
};

export const FAQCategory = (props: ICategory) => {
    let isLastItem = false;
    const getFAQs = props.items.map((__, key) => {
        isLastItem = key === props.items.length - 1;
        const FAQProps = {
            key: key,
            question: __.question,
            text: __.text,
            wrapperStyle: isLastItem ? { borderBottom: 0 } : {},
        };
        return <FAQ {...FAQProps} />;
    });

    const figureStyle: any = {
        ...styles.figure,
        backgroundImage: `url(${props.image})`,
    };

    const title = <h4 style={styles.title}>{props.name}</h4>;

    return (
        <div style={styles.wrapper}>
            <figure style={figureStyle}></figure>
            <CollapsibleDropDown
                title={title}
                wrapperStyle={styles.wrapperStyle}
                childStyle={styles.childStyle}
                arrowStyle={styles.arrowDownIcon}
            >
                <div style={styles.FAQsWrapper}>{getFAQs}</div>
            </CollapsibleDropDown>
        </div>
    );
};
